<template>
    <v-row justify="center">
    <v-dialog v-model="dialogLocal" width="650">
      <v-card>
        <v-form ref="es" action="#" @submit.prevent="beforeCreateForm('update carpark')" lazy-validation>
        <v-card-title class="justify-space-between" :style="{'background-color': topbarcolor}" style="color: white; padding-top: 5px; padding-bottom: 5px">
          <span class="headline">{{readonly ? 'View' : 'Update'}} Controller: {{modalInfo.WLControllerID}}</span>
          <v-btn text @click="$emit('closed', false)" fab depressed small><v-icon small color="white">fas fa-times</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
                <v-col cols="12" md="12">
                    <v-overlay
                        :absolute="true"
                        :opacity="1"
                        :z-index="999"
                        :value="modal_loader"
                        color="#D2D7DF"
                        >
                        <v-progress-circular indeterminate size="100"></v-progress-circular>
                        </v-overlay>
                    <v-text-field
                        dense
                        outlined
                        v-model="form.GateControllerID.item"
                        label="Controller ID"
                        required
                        disabled
                    ></v-text-field>
                    <v-autocomplete
                    dense
                    outlined
                    placeholder="Select"
                    label="Operator"
                    v-model="form.operator.selected"
                    @change="execFilter"
                    :items="form.operator.items"
                    item-text="name"
                    item-value="OperatorID"
                    :rules="form.operator.rule"
                    :loading="form.operator.loader"
                    :disabled="form.operator.disable || readonly"
                    >
                    </v-autocomplete>
                    <v-autocomplete
                    dense
                    outlined
                    placeholder="Select"
                    label="Car Park"
                    v-model="form.carpark.selected"
                    :items="form.carpark.items"
                    item-text="name"
                    item-value="CarParkID"
                    :rules="form.carpark.rule"
                    :loading="form.carpark.loader"
                    :disabled="form.carpark.disable || readonly"
                    >
                    </v-autocomplete>
                    <v-text-field
                        dense
                        outlined
                        v-model="form.PoleNo.item"
                        :rules="form.PoleNo.rule"
                        label="Pole No."
                        required
                        :disabled="readonly"
                    ></v-text-field>
                    <v-text-field
                        dense
                        outlined
                        v-model="form.Mainboard.item"
                        :rules="form.Mainboard.rule"
                        label="Mainboard"
                        required
                        :disabled="readonly"
                    ></v-text-field>
                    <v-text-field
                        dense
                        outlined
                        v-model="form.Remark.item"
                        :rules="form.Remark.rule"
                        label="Remark"
                        required
                        :disabled="readonly"
                    ></v-text-field>
                </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn v-if="!readonly" tile type="submit" small color="primary"><v-icon left x-small dark>fa fa-save</v-icon>Save</v-btn>
            <v-spacer></v-spacer>
            <v-btn tile color="blue darken-1" text @click="$emit('closed', false)">Close</v-btn>
        </v-card-actions>
        </v-form>
        <alertbox :dialog="innerModal" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" @confirm="onConfirm" @closed="onClosed"></alertbox>
      </v-card>
    </v-dialog>
    </v-row>
</template>

<script>
import alertbox from './Alert';

  export default {
    props: ['dialog', 'modalInfo', 'customText', 'system', 'master', 'readonly', 'carpark', 'operator'],

    data() {
        return {
            dialogLocal: false,
            items: [],
            headers: [
                { text: '#', value: 'row' },
                { text: 'ID', value: 'ID' },
                { text: 'User ID', value: 'userID' },
                { text: 'Type', value: 'Type' },
                { text: 'Role', value: 'Role'},
            ],
            tableloading: false,
            swal: {
                notification: false,
                message: '',
                scolor: '',
            },
            innerModal: false,
            ma: {
                modal: false,
                modal_action_type: '',
                modalInfo: [],
                customText: [],
                edit_modal: false,
                view_modal: false,
                confirmEdit: false,
                confirmCreate: false,
            },
            form: {
                ControllerUUID: {item: ""},
                RefControllerID: {item: "", rule: []},
                ControllerToken: {item: ""},
                GateControllerID: {item: "", rule: []},
                operator: {
                    items: [],
                    itemsFull: [],
                    selected: '',
                    loader: false,
                    disable: false,
                    rule: []
                },
                carpark: {
                    items: [],
                    itemsFull: [],
                    selected: '',
                    loader: false,
                    disable: false,
                    rule: []
                },
                PoleDesc: {item: "", rule: []},
                GateDesc: {item: "", rule: []},
                Remark: {item: "", rule: []},
                Enabled: {item: "", rule: []},
                CreateDate: {item: "", rule: []},
                UpdateDate: {item: "", rule: []},
                TokenRef: {item: "", rule: []},
                PoleNo: {item: "", rule: []},
                Mainboard: {item: "", rule: []},
            },
            modal_loader: false,
            topbarcolor: JSON.parse(localStorage.getItem('theme')).topbarcolor
        }
    },

    components: {alertbox},

    watch: {
        dialog: {
        handler: function(value) {
            this.modalHandler();
            if(value == true){
                this.handleValue();
            }
        },
        },

        dialogLocal: {
        handler: function(value) {
            this.modalCloseHandler();
        },
        },
    },

    methods: {
        async beforeCreateForm(flag){
            //must set this in order to use 'this' as 'self' inside settimeout etc..
            let self = this;

            this.form.carpark.rule = [
                v => !!v || 'This is required',
            ];

            this.form.GateControllerID.rule = [
                v => !!v || 'This is required',
            ];

            this.form.PoleDesc.rule = [
                v => !!v || 'This is required',
            ];

            this.form.GateDesc.rule = [
                v => !!v || 'This is required',
            ];

            this.form.RefControllerID.rule = [
                v => !!v || 'This is required',
            ];

            setTimeout(function () {
                //self.$refs.image.resetValidation();
                //self.$refs.image.reset();

             if (self.$refs.es.validate()) {
                    self.innerModal = true;
                    self.ma.modalInfo = {id: 1, name: 2};
                    self.ma.modal_action_type = flag;
                }
            });
        },

        modalHandler(){
            this.dialogLocal = !this.dialogLocal;
        },

        modalCloseHandler(){
            if (this.dialogLocal == false){
                this.$emit('closed', false);
            }
        },

        handleValue(){
            this.form.GateControllerID.rule = [];
            this.form.PoleDesc.rule = [];
            this.form.GateDesc.rule = [];
            this.form.Remark.rule = [];
            this.form.Enabled.rule = [];
            this.form.RefControllerID.rule = [];
            this.form.carpark.rule = [];

            let operator = [];
            operator.push({name: 'Select', OperatorID: ''});
            let filteredoperator = this.operator.filter(item => item.OperatorID !== "");
            for (const [index, item] of filteredoperator.entries()){
                operator.push(item);
            }

            this.form.operator.items = operator;

            this.form.carpark.selected = "";
            let filteredcarparkfromoperatorid = this.carpark.filter(item => item.OperatorID == this.modalInfo.OperatorID);
            let carpark = [];
            carpark.push({name: 'Select', CarParkID: '', OperatorID: ''});
            for (const [index, item] of filteredcarparkfromoperatorid.entries()){
                carpark.push(item);
            }
            this.form.carpark.items = carpark;
            this.form.carpark.selected = this.modalInfo.CarParkID;

            this.form.ControllerUUID.item = this.modalInfo.WLControllerUUID;
            this.form.RefControllerID.item = this.modalInfo.WLControllerRef;
            this.form.GateControllerID.item = this.modalInfo.WLControllerID;
            this.form.operator.selected = this.modalInfo.OperatorID;
            this.form.Remark.item = this.modalInfo.WLControllerRemark;
            this.form.Enabled.item = this.modalInfo.WLControllerEnabled;
            this.form.CreateDate.item = this.modalInfo.WLControllerCreatedDateTime;
            this.form.UpdateDate.item = this.modalInfo.WLControllerUpdatedDateTime;
            this.form.TokenRef.item = this.modalInfo.WLControllerToken;
            this.form.PoleNo.item = this.modalInfo.PoleDesc;
            this.form.Mainboard.item = this.modalInfo.MBDesc;
        },

        execFilter(){
            this.form.carpark.items = [];
            this.form.carpark.selected = "";
            if (this.form.operator.selected !== ""){
                let a = this.carpark.filter(item => item.OperatorID == this.form.operator.selected);
                console.log(a);
                this.form.carpark.items.push({name: "Select", CarParkID: "", OperatorID: ''});
                for (const [index, item] of a.entries()){
                    this.form.carpark.items.push(item);
                }
            }

            else{
                this.form.carpark.items.push({name: 'Select', CarParkID: '', OperatorID: ''});
                for (const [index, item] of this.carpark.entries()){
                    this.form.carpark.items.push(item);
                }
            }
        },

        //set the action to be sent to watcher to execute the create/edit function
        async onConfirm(value){
            this.form.RefControllerID.item = Number(this.form.RefControllerID.item);
                if (this.ma.modal_action_type == 'update carpark'){
                    this.form.flag = 'update carpark';
                    this.$emit('confirm', this.form);
                }

                this.innerModal = false;
        },

        onClosed(value){
            if (value == false){
                this.innerModal = value;
            }
        },
    }
  }
</script>